// lang-en.ts

export const LANG_EN_NAME = 'en';

export const LANG_EN_TRANS = {
    'User Name': 'User Name',
    'Password': 'Password',
    'LOG IN': 'LOG IN',
};
